import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route path="/manage-users/detail" element={<Pages.ManageUserDetail />} />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route path="/manage-subadmin/detail" element={<Pages.SubadminDetail />} />
        <Route path="/manage-subadmin/roles" element={<Pages.ManageSubadminRoles />} />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route path="/manage-subadmin/roles/detail" element={<Pages.RoleDetail />} />
       
        <Route path="/manage-notifications" element={<Pages.ManageNotifications />} />
        <Route path="/manage-notifications/add" element={<Pages.AddNotification />} />
        <Route path="/manage-notifications/detail" element={<Pages.NotificationDetail />} />
        <Route path="/recieved-notifications" element={<Pages.RecievedNotifications />} />
        <Route path="/manage-system-settings" element={<Pages.ManageSystemSettings />} />
        <Route path="/manage-system-settings/add-email-template" element={<Pages.AddEmailTemplate />} />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route path="/manage-profile/change-password" element={<Pages.ChangePassword />} />
 
        <Route path="/manage-promotions" element={<Pages.ManagePromotion />} />
        <Route path="/manage-promotions/add" element={<Pages.AddPromotion />} />
        <Route path="/manage-promotions/edit" element={<Pages.AddPromotion />} />
        <Route path="/manage-promotions/view" element={<Pages.ViewPromotion />} />
        <Route path="/manage-stores" element={<Pages.ManageStores />} />
        <Route path="/manage-stores/add" element={<Pages.AddStore />} />
        <Route path="/manage-stores/detail" element={<Pages.StoreDetail />} />
        <Route path="/manage-qr-code" element={<Pages.ManageQrCode />} />
        <Route path="/manage-rewards" element={<Pages.ManageRewards />} />
        <Route path="/manage-rewards/add" element={<Pages.AddRewards />} />
        <Route path="/manage-rewards/detail" element={<Pages.RewardsDetail />} />
        <Route path="/manage-transactions" element={<Pages.ManageTransction />} />
        <Route path="/manage-transactions/view" element={<Pages.ViewTransction />} />
        <Route path="/manage-activity-logs" element={<Pages.ManageActivityLogs />} />
        <Route path="/manage-feedback-and-reports" element={<Pages.ManageFeedbackReports />} />
      </Route>
    </Routes>
  );
};

export default Routing;
